module.exports = __webpack_public_path__ + "img/Attracting_Advancing_Diverse_Talent.7aaad54a.jpg";